import gql from 'graphql-tag';

import { executeGqlQuery } from 'src/graphql/client';
import { getSingleProp, unwrapEdges } from 'src/lib/graphql';

const QUERY = gql`
  query ContentTaxonomies {
    contentTaxonomies {
      edges {
        node {
          id
          name
          default
        }
      }
    }
  }
`;

export const queryContentTaxonomies = () =>
  executeGqlQuery({
    query: QUERY,
  }).then(({ data }) => {
    const contentTaxonomies = getSingleProp(data);
    return unwrapEdges(contentTaxonomies.edges);
  });
